import React from "react";
import ButtonComponent from "../../../atoms/button";
import { ADD_ON, INCL_OF_ALL_TAXES, S } from "../../../../constants/common/common";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { updateCurrency } from "../../../../utils/common";
import dynamic from "next/dynamic";
const PriceBreakUp = dynamic(() => import("./priceBreakUp"), {
  ssr: false,
});

/**
 * Component that renders the footer for the mobile layout, displaying
 * the total add-on count and total price, and handling the continuation of the process.
 *
 * @param {Object} props - The component props.
 * @param {function} props.calculateAddonCount - Function to calculate the count of add-ons.
 * @param {number} props.totalPrice - The total price of the items, including add-ons.
 * @param {function} props.onContinueClick - Function to handle the continuation action.
 */
const MobileFooter = ({ calculateAddonCount, totalPrice, onContinueClick }) => {
  const selectedCurrency = useSelector((state) => state?.currencyList?.userSelectedCurrency);

  return (
    <div className="fixed bottom-0 flex w-full flex-col bg-white-900 shadow-top">
      <div className="bg-white flex w-full items-center justify-between gap-[12px] border-t border-[#F5F5F5] px-[16px] py-8">
        <div className="flex items-center gap-[8px] py-[12px]">
          <div className="flex flex-col gap-[2px]">
            <span className="flex items-center gap-4 text-[17px] font-bold leading-[20px] text-[#333333]">
              {updateCurrency(selectedCurrency, totalPrice)} <PriceBreakUp isMobile={true} />
            </span>

            <span className="block font-inter text-[12px] font-medium leading-[16.8px] text-[#757575]">
              {INCL_OF_ALL_TAXES}
            </span>
          </div>
        </div>

        <ButtonComponent
          onClick={onContinueClick}
          buttonVariant="filled"
          classes={`${calculateAddonCount() === 0 ? "bg-opacity-0" : ""}  transition-all duration-300 ease-in-out font-600 text-fnp-300 border border-lightOliveGreen py-12 px-16 text-16 transition-all duration-300 ease-in-out inline-flex w-full`}
          label={
            calculateAddonCount() > 0 ? (
              <div className="flex items-center justify-center gap-8">
                Continue
                <span className="h-[6px] w-[6px] rounded-full bg-white-900" />
                <span className="text-14 font-400">
                  {calculateAddonCount()} {ADD_ON}
                  {calculateAddonCount() > 1 ? S : ""}
                </span>
              </div>
            ) : (
              "Skip & Continue"
            )
          }
          size=""
          btnParentClasses={`flex-1 w-[70%]`}
          labelStyle={`${calculateAddonCount() > 0 ? "text-16" : "text-fnp-300 text-16 font-600"}`}
        />
      </div>
    </div>
  );
};

MobileFooter.propTypes = {
  calculateAddonCount: PropTypes.func.isRequired,
  totalPrice: PropTypes.number.isRequired,
  onContinueClick: PropTypes.func.isRequired,
};

export default MobileFooter;
